export const residentImageFolder = "user-images";
export const speak2CdnDevBucketUrl = "https://speak2-cdn-dev.s3.amazonaws.com"